import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  API,
  defaultLimitPagination,
  fileUpload,
  get,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { debounce } from "lodash";
import MainBody from "../../components/MainBody/MainBody";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../components/Pagination";

import { useTrust } from "../../lib/context/TrustContext";
import {
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
// import ExpandABATransactions from "./ExpandABATransactions";
import { Button } from "../../components/ui/button";
import { LucideFolderGit } from "lucide-react";
import Spin from "../../components/Spin";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { DateInputPicker } from "../../components/DateInputPicker";
import { toast } from "../../components/ui/use-toast";
import moment from "moment";
import { Input } from "../../components/ui/input";
import ExpandPayment from "../Payments/ExpandPayment";
import AddEditPayment from "../Payments/AddEditPayment";
// import ABAActionButton from "./ABAActionButton";
import CustomTooltip from "../../components/CustomTooltip";
import { useOrganization } from "../../lib/context/OrganisationContext";

const GenerateABA = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { organizationData } = useOrganization();

  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const [abaList, setAbasList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [selectedRowIds, setSelectedRowIds] = useState([]);

  const [generateABAShow, setGenerateABAShow] = useState(false);
  const [nextModal, setNextModal] = useState(false);
  const [transactionDate, setTransactionDate] = useState(new Date());
  const [fileNote, setFileNote] = useState();

  const { trustId } = useTrust();

  const [paymentId, setPaymentId] = useState(null);
  const [showAddEditPayment, setShowAddEditPayment] = useState(false);
  const [edit, setEdit] = useState(false);
  const [editItem, setEditItem] = useState(null);

  const toggleShowAddEditPayment = () => {
    if (showAddEditPayment) {
      setEdit(false);
      setEditItem(null);
      setPaymentId(null);
    }
    setShowAddEditPayment(!showAddEditPayment);
  };

  const toggleGenerateABAShow = () => {
    if (generateABAShow) {
      setNextModal(false);
      setTransactionDate(new Date());
    }
    setGenerateABAShow(!generateABAShow);
  };

  const fetchAbas = useCallback(
    async (passLimit, passPage) => {
      if (trustId) {
        try {
          setLoading(true);
          const { data } = await get(
            `${API.GET_ABA_LIST}?limit=${
              passLimit ? passLimit : limit ? limit : defaultLimitPagination
            }&page=${passPage ? passPage : page ? page : 1}&search=${
              searchParam ? searchParam : ""
            }&sort_column=${sortField ? sortField : ""}&sort_order=${
              sortOrder ? sortOrder : ""
            }&trust_id=${trustId ? trustId : ""}&aba_file=2`,
          );

          setLoading(false);
          setLimit(data?.data?.per_page);
          setPage(data?.data?.current_page);
          setTotal(data?.data?.total);
          setFrom(data?.data?.from);
          setTo(data?.data?.to);
          const abaList = data.data.data;
          // setNotSelectedRowIds(notSelectedIds);
          setAbasList(abaList);
          return data.data;
        } catch (error) {
          setLoading(false);
          setAbasList([]);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortOrder, sortField, trustId],
  );

  const arrayRemove = (arr, value) => {
    return arr.filter(function (ele) {
      return ele !== value;
    });
  };

  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    onSelectAll: (row, isSelect) => {
      if (abaList?.length > 0) {
        if (row) {
          const ids =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect?.map((item) => {
              return item?.key;
            });
          setSelectedRowIds(selectedRowIds ? selectedRowIds.concat(ids) : ids);
        } else {
          const removableData =
            isSelect &&
            isSelect?.length > 0 &&
            isSelect.map(function (data) {
              return data?.key;
            });
          setSelectedRowIds(
            selectedRowIds
              ? selectedRowIds.filter((item) => !removableData.includes(item))
              : [],
          );
        }
      }
    },
    onSelect: (row, isSelect) => {
      if (isSelect) {
        setSelectedRowIds((keys) => [...keys, row?.key]);
      } else {
        setSelectedRowIds(arrayRemove(selectedRowIds, row?.key));
      }
    },
  };

  const abasGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: abaList[i]?.id,
        id: abaList[i]?.id,
        transaction_date: abaList[i]?.transaction_date
          ? abaList[i]?.transaction_date
          : "",
        name: abaList[i]?.multiple_payments
          ? `Multiple Payee`
          : abaList[i]?.payment_detail[0]?.contact
            ? `${formatSubcontractorName(
                abaList[i]?.payment_detail[0]?.contact,
              )} - (${getModuleNamingBySlug(
                organizationData?.organizationData,
                "contacts",
                "C",
              )?.charAt(0)})`
            : `${formatSubcontractorName(
                abaList[i]?.payment_detail[0]?.vendor,
              )} - (${getModuleNamingBySlug(
                organizationData?.organizationData,
                "vendors",
                "V",
              )?.charAt(0)})`,
        exc_gst_total_amount: abaList[i]?.total_amount
          ? "$" +
            formatNumber(
              Number(
                formatNumber(Number(abaList[i]?.total_amount)).replace(
                  /,/g,
                  "",
                ) / 1.1,
              ),
            )
          : `$0.00`,

        amount: abaList[i]?.amount
          ? "$" + formatNumber(Number(abaList[i]?.amount))
          : `$0.00`,

        fees: abaList[i]?.fees
          ? "$" + formatNumber(Number(abaList[i]?.fees))
          : `$0.00`,
        total_amount: abaList[i]?.total_amount ? (
          <b>{`$${formatNumber(Number(abaList[i]?.total_amount))}`}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        total_amount_exc: abaList[i]?.total_amount_exc ? (
          <b>{`$${formatNumber(Number(abaList[i]?.total_amount_exc))}`}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        total_tax_amount:
          abaList[i]?.payment_detail[0]?.tax === "1" &&
          abaList[i]?.total_tax_amount ? (
            <CustomTooltip
              message={
                abaList[i]?.payment_detail[0]?.tax === "1" &&
                ` (${abaList[i]?.payment_detail[0]?.sub_asset?.tax_percentage}%)`
              }
            >
              <b>{`$${formatNumber(Number(abaList[i]?.total_tax_amount))}`}</b>
            </CustomTooltip>
          ) : (
            <b>{"$0.00"}</b>
          ),
        file_note: abaList[i]?.file_note
          ? `${abaList[i]?.is_refund ? "Refunded - " : ""} ${
              abaList[i]?.file_note
            }`
          : "",
        is_refund: abaList[i]?.is_refund ? abaList[i]?.is_refund : "",
        expandData: abaList[i]?.payment_detail,
        // action: (
        //   <>
        //     <ABAActionButton
        //       id={abaList[i]?.id}
        //       item={abaList[i]}
        //       setPaymentId={setPaymentId}
        //       setEdit={setEdit}
        //       setEditItem={setEditItem}
        //       toggleShowAddEditPayment={toggleShowAddEditPayment}
        //     />
        //   </>
        // ),
      });
    }
    return items;
  };

  const abas = abasGenerator(abaList?.length);

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "transaction_date",
      text: "Payment Date",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "name",
      text: "Name",
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "amount",
    //   text: "Amount",
    // },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "fees",
      text: "Fees",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "total_amount",
      text: "Total Amount (Inc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "total_amount_exc",
      text: "Total Amount (Exc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "total_tax_amount",
      text: "Total Tax",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "file_note",
      text: "File Note",
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   text: "Action",
    //   dataField: "action",
    //   align: "center",
    //   headerAlign: "center",
    // },
  ];

  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  useEffect(() => {
    navigate(
      `?tab=generate-aba&limit=${limit ? limit : defaultLimitPagination}&page=${
        page ? page : 1
      }&search=${searchParam ? searchParam : ""}&sort_column=${
        sortField ? sortField : ""
      }&sort_order=${sortOrder ? sortOrder : ""}`,
      {
        replace: true,
      },
    );
  }, [navigate, limit, searchParam, page, sortField, sortOrder]);

  useEffect(() => {
    fetchAbas();
  }, [fetchAbas]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    debouncedSave(nextValue);
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchAbas(limit, 1);
  };

  const handleChangePage = (page) => {
    setPage(page);
    fetchAbas(limit, page);
  };

  const [totalAmount, setTotalAmount] = useState();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const totalSelectedValue = (selectedRowData) => {
    let amount = 0;
    for (let k = 0; k < selectedRowData.length; k++) {
      amount =
        amount +
        Number(
          abaList?.find((item) => item?.id === selectedRowData[k])
            ?.total_amount,
        );
    }
    setTotalAmount(amount);
  };

  useEffect(() => {
    totalSelectedValue(selectedRowIds);
  }, [selectedRowIds, totalSelectedValue]);

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandPayment
          id={row?.id}
          expandList={true}
          expandData={row?.expandData}
        />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  const handleGenerateAba = async (sendEmail) => {
    if (!selectedRowIds.length) {
      toast({
        variant: "destructive",
        description: "Please select rows",
        duration: 3000,
      });
      return;
    }
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("trust_id", trustId);
      formData.append("file_note", fileNote);

      if (selectedRowIds?.length > 1) {
        formData.append(
          "transaction_date",
          transactionDate ? moment(transactionDate)?.format("DD-MM-YYYY") : "",
        );
      }
      if (selectedRowIds?.length > 0) {
        for (let i = 0; i < selectedRowIds?.length; i++) {
          formData.append(`aba_ids[${i}]`, selectedRowIds[i]);
        }
      }

      formData.append("send_email", sendEmail);

      const { data } = await fileUpload(API.GENERATE_ABA, formData, {});
      setSelectedRowIds([]);
      setTransactionDate(new Date());
      toggleGenerateABAShow();
      // setGenerateModal(false);
      setLoading(false);
      if (data) {
        fetchAbas(limit, page);
      }
    } catch (e) {
      setLoading(false);
    }
  };

  return (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        innerBody={true}
        parentHeight={true}
        mainClassName="w-[calc(100%-3rem)]"
        actionContent={
          <div className="flex items-center gap-3 flex-wrap">
            <div>
              Selected Total:{" "}
              <span className="text-green-600 font-bold">
                {totalAmount ? `$${formatNumber(totalAmount)}` : "$0.00"}
              </span>
            </div>
            <div>
              Selected Record:{" "}
              <span className="text-green-600 font-bold">
                {selectedRowIds?.length}
              </span>
            </div>
            <Button
              onClick={() => toggleGenerateABAShow()}
              disabled={selectedRowIds?.length === 0}
            >
              <div className="flex items-center gap-1">
                <LucideFolderGit size={18} />
                <span>Generate .ABA </span>
              </div>
            </Button>
          </div>
        }
        loading={loading}
      >
        <div className="custom-table">
          <div className="table-body-class sm:max-h-[640px]">
            <BootstrapTable
              keyField="key"
              remote
              data={abas}
              columns={columns}
              selectRow={selectRow}
              expandRow={expandRow}
              onTableChange={handleTableChange}
              rowClasses={(row) => {
                if (row?.is_refund) {
                  return `${TRClasses} bg-muted dark:text-gray-400 text-gray-600 dark:bg-muted/50`;
                }
                return TRClasses;
              }}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />
        </div>
      </MainBody>

      <ResponsiveDrawerForm
        description={""}
        title={"Generate .ABA"}
        handleOpen={() => {}}
        handleClose={() => {
          setNextModal(false);
          setTransactionDate(new Date());
        }}
        className={"w-1/4"}
        open={generateABAShow}
        buttonClassName={""}
        setOpen={setGenerateABAShow}
        mobileCancelHidden={true}
        confirmBox={true}
        write={true}
      >
        <div className="relative">
          {loading && (
            <Spin expand={true} smallModal={true} fullscreen={true} />
          )}
          <div className="text-left">
            {nextModal ? (
              <div className="text-center">
                Would you like to send remittance advice via email?
              </div>
            ) : (
              <>
                {selectedRowIds?.length > 1 && (
                  <div className="text-center">
                    Please Select Transaction Date and Enter File Note
                  </div>
                )}
                <div className="grid gap-4 mt-4">
                  {selectedRowIds?.length > 1 && (
                    <div className="grid gap-2">
                      <Label htmlFor="file_note">
                        <CustomLabelText
                          required={true}
                          labelText="Transaction Date"
                        />
                      </Label>
                      <DateInputPicker
                        date={transactionDate ? transactionDate : new Date()}
                        onSelect={(e) => {
                          setTransactionDate(e);
                        }}
                        className={"w-[200px] text-left"}
                        inputClassName="w-full"
                        icon={true}
                        disabledDate={{ after: new Date() }}
                      />
                    </div>
                  )}
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        required={true}
                        labelText="File Note"
                        bottomAlign={true}
                      />
                    </Label>
                    <Input
                      type="text"
                      name="file_note"
                      value={fileNote ? fileNote : ""}
                      onChange={(e) => {
                        setFileNote(e?.target?.value);
                      }}
                      autoComplete="off"
                      onKeyPress={(e) => {
                        e.which === 13 && e.preventDefault();
                      }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="modal-footer pt-4 border-t mt-4 flex items-center justify-center">
            <Button
              type="submit"
              onClick={(e) => {
                e.preventDefault();
                nextModal ? handleGenerateAba(1) : handleGenerateAba(0);
              }}
            >
              {nextModal ? "Yes" : "Submit"}
            </Button>
            {nextModal && (
              <Button
                className="reset ml-3"
                data-dismiss="modal"
                aria-label="Close"
                variant="secondary"
                onClick={(e) => {
                  e.preventDefault();
                  handleGenerateAba(0);
                }}
              >
                No
              </Button>
            )}
            <Button
              className="reset ml-3"
              data-dismiss="modal"
              aria-label="Close"
              variant="secondary"
              onClick={(e) => {
                e.preventDefault();
                toggleGenerateABAShow();
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </ResponsiveDrawerForm>
      <ResponsiveDrawerForm
        description={""}
        title={edit ? "Edit Payment(s)" : "Add Payment(s)"}
        handleOpen={() => {}}
        handleClose={() => {
          setEdit(false);
          setPaymentId();
          setEditItem(null);
        }}
        buttonText={""}
        open={showAddEditPayment}
        buttonClassName={""}
        setOpen={setShowAddEditPayment}
        className={"md:max-w-[95vw] md:max-h-[95vh]"}
        mobileCancelHidden={true}
        write={true}
      >
        <AddEditPayment
          edit={edit}
          editItem={editItem}
          toggleShowAddEditPayment={toggleShowAddEditPayment}
          id={paymentId}
          trustId={trustId}
          fetchPaymentData={() => fetchAbas(limit, page)}
        />
      </ResponsiveDrawerForm>
    </>
  );
};

export default GenerateABA;
